var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g815",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.844,
    height: 31.844,
    viewBox: "0 0 31.844 31.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path819",
    d: "M0-682.665H31.844v31.844H0Z",
    transform: "translate(0 682.665)",
    fill: "none",
    stroke: "#595959",
    strokeWidth: 1.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g817",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g823",
    transform: "translate(4.522 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path825",
    d: "M-181.353-261.758l2.526-10.7-3.276-1.078-.134-.044-2.943-.969a.383.383,0,0,0-.472.213l-4.183,9.783a4.534,4.534,0,0,0,1.613,5.631,4.469,4.469,0,0,0,3.219.675A4.405,4.405,0,0,0-181.353-261.758Z",
    transform: "translate(190.226 274.565)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g827",
    transform: "translate(4.523 15.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M-101.208-22.353c-1.565.006-5.349-.174-6.722-.949l-.061.142a4.534,4.534,0,0,0,1.613,5.631,4.471,4.471,0,0,0,3.22.674,4.4,4.4,0,0,0,3.649-3.513l.49-2.074a14.1,14.1,0,0,0-1.987.071l-.2.018",
    transform: "translate(108.383 23.303)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g831",
    transform: "translate(5.654 21.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "M-40.882,0l-2,6.077",
    transform: "translate(42.883)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g835",
    transform: "translate(0.838 27.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path837",
    d: "M-98.428,0-102.2.22a1.162,1.162,0,0,0-1.036.8.216.216,0,0,0,.138.273l7.656,2.52a.216.216,0,0,0,.273-.138,1.162,1.162,0,0,0-.36-1.256Z",
    transform: "translate(103.244)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g839",
    transform: "translate(15.922 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path841",
    d: "M-51.627-261.758l-2.526-10.7,3.276-1.078.134-.044,2.943-.969a.383.383,0,0,1,.472.213l4.183,9.783a4.534,4.534,0,0,1-1.613,5.631,4.469,4.469,0,0,1-3.219.675A4.405,4.405,0,0,1-51.627-261.758Z",
    transform: "translate(54.153 274.565)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g843",
    transform: "translate(17.959 15.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M-84.585-131.779a4.471,4.471,0,0,0,3.22-.674,4.535,4.535,0,0,0,1.613-5.632l-.061-.142a9.6,9.6,0,0,1-5.014,1.078c-1.38-.055-2.638-.284-3.9-.218l.49,2.074A4.4,4.4,0,0,0-84.585-131.779Z",
    transform: "translate(88.724 138.226)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g847",
    transform: "translate(24.189 21.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M0,0,2,6.077",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g851",
    transform: "translate(22.869 27.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path853",
    d: "M-38.762-67.336l-1.565.515a.216.216,0,0,1-.273-.138,1.162,1.162,0,0,1,.36-1.256l2.9-2.416,3.769.22a1.162,1.162,0,0,1,1.036.8.217.217,0,0,1-.138.273l-6.09,2",
    transform: "translate(40.659 70.63)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g855",
    transform: "translate(23.867 1.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path857",
    d: "M0-17.589l.405-.861",
    transform: "translate(0 18.449)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g859",
    transform: "translate(27.26 7.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path861",
    d: "M-19.371,0l-.948.08",
    transform: "translate(20.319)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g863",
    transform: "translate(26.217 3.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path865",
    d: "M-15.964,0l-.781.543",
    transform: "translate(16.745)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g867",
    transform: "translate(7.571 1.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path869",
    d: "M-8.278-17.589l-.405-.861",
    transform: "translate(8.683 18.449)",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g871",
    transform: "translate(3.636 7.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path873",
    d: "M0,0,.948.08",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g875",
    transform: "translate(4.845 3.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path877",
    d: "M0,0,.781.543",
    fill: "none",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.49e9ee9de45b7de23c134d957ee6fc55.svg";
export { ForwardRef as ReactComponent };